import { FC } from 'react'
import { useUserProfileContext } from '../../../../context/UserProfileContext'
import { ExpandableDescription } from '../../../../helpers/ExpandableDescription'

interface ServiceCardProps {
  title: string
  description: string
  rate: string
  rateType?: string
  pricing: number
}

const ServiceCard: FC<ServiceCardProps> = ({ title, description, rate, rateType, pricing }) => {
  
  return (
    <div className='service-card'>
      <div className='service-card__title'>{title.replaceAll('_', ' ').replaceAll('-', ' ')}</div>
      <div className='service-card__content'>
        <div className='service-card__description'>
          <div className='service-card__text'>
            <ExpandableDescription text={description} html />
          </div>
        </div>
        <div className='service-card__rate'>
          <div className='service-card__rate-label'>Rate</div>
          <div className='service-card__rate-value text-capitalize'>
            {/* PR-I-85: formato "USD 1,200/Hourly" — entero con separador de miles, prefijo USD
                (sin simbolo $). Consistente entre tab publica y formulario de edit. */}
            {rate == 'under request'
              ? ''
              : `USD ${new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(Math.trunc(Number(pricing) || 0))}/`}
            {rate}
          </div>
        </div>
      </div>
    </div>
  )
}

const ExpertiseTab: FC = () => {
  const { data } = useUserProfileContext()

  const services = data?.expertise || []

  /* if (!services.length) {
    return (
      <div className='expertise-tab'>
        <div className='expertise-tab__empty'>No expertise information available.</div>
      </div>
    )
  } */

  return (
    <div className='expertise-tab'>
      <div className='expertise-tab__services'>
        {services.map((service: any, index: number) => (
          <ServiceCard
            key={index}
            title={service.title}
            description={service.content}
            rate={service.rate}
            rateType={service?.rateType || ''}
            pricing={service?.pricing || 0}
          />
        ))}
      </div>
    </div>
  )
}

export { ExpertiseTab }
